import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { REGISTER_USER } from "../../redux/constant";
import "./RegistrationPage.scss";
import Input from "../../lib/ui/Input/Input";

const RegistrationPage = () => {
  const { restaurant, id, table } = useParams();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const redirectTo = useSelector((state) => state.user.redirectTo);
  // Get mobile number from localStorage
  const mobile = localStorage.getItem("user_mobile");

  useEffect(() => {
    console.log("redirectTo", redirectTo);
    if (!redirectTo) return;

    if (redirectTo === "MENU") {
      navigate(`/${restaurant}/${id}/${table}/menu`);
    }

    // dispatch({ type: "CLEAR_REDIRECT" }); // reset redirect
  }, [redirectTo]);

  const handleSubmit = async () => {
    if (!name.trim()) {
      alert("Please enter your name");
      return;
    }

    // const payload = {
    //   name: name,
    //   email: email,
    //   mobile: mobile
    // };

    try {
      const request = {
        restaurantId: id,
        tableNumber: table,
        tableOtp: "",
        customer: {
          contactNumber: mobile,
          name: name,
          email: email,
        },
      };

      // 3️⃣ Dispatch API
      dispatch({ type: REGISTER_USER, payload: request });

      console.log("request......", request);

      //  const userInfoRaw = localStorage.getItem('userInfo');

      //  if (!userInfoRaw) {
      //    toast.error('Please enter data.');
      //    return;
      //  }

      //  const userInfo = JSON.parse(userInfoRaw);

      //  console.log("userInfo",userInfo)

      // if (userInfo.isUserAlreadyRegister === 1)
      // navigate(`/${restaurant}/${id}/${table}/menu`)
    } catch (error) {
      console.error(error);
      alert("API error");
    }
  };

  return (
    <div className="reg-wrapper">
      <h2 className="reg-title">Registration</h2>

      <div className="reg-box">
        <label>Mobile Number</label>
        <Input value={mobile} disabled className="input disabled" />

        <label>Full Name</label>
        <Input
          placeholder="Enter your name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="input"
        />

        <label>Email (Optional)</label>
        <Input
          placeholder="Enter email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="input"
        />

        <button className="reg-btn btn" onClick={handleSubmit}>
          Registrate
        </button>
      </div>
    </div>
  );
};

// Simple Style
const styles = {
  wrapper: {
    padding: "20px",
    marginTop: "30px",
  },
  title: {
    textAlign: "center",
    marginBottom: "20px",
  },
  formBox: {
    background: "#fff",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
  },
  label: {
    fontSize: "14px",
    fontWeight: "bold",
    marginTop: "10px",
  },
  input: {
    width: "100%",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    marginTop: "5px",
  },
  inputDisabled: {
    width: "100%",
    padding: "10px",
    borderRadius: "8px",
    background: "#f1f1f1",
    border: "1px solid #ddd",
    marginTop: "5px",
  },
  button: {
    width: "100%",
    marginTop: "20px",
    padding: "12px",
    background: "#ff5252",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "16px",
    cursor: "pointer",
  },
};

export default RegistrationPage;
